<template>
  <div> 
    <!--<transition :name="transitionName">   -->
    <transition name="fade">
      <router-view></router-view>  
		</transition>
    <!-- 底部导航 -->  
    <nav-tabbar ></nav-tabbar>
    <!-- 底部导航 end--> 
  </div>
</template> 
<script>
import NavTabbar from '@/components/NavTabbar.vue' 

export default {
  name: "Act1Index",
  components: {
    'nav-tabbar': NavTabbar,    
  },
  data() {
    return {   
        transitionName:''
    };
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      console.log(to.meta)
       console.log(from.meta)
      if(to.meta.index > from.meta.index){
	    //设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  },
  mounted() {
    console.log(123)
  },
  created() {
    //移除loading
    this.removeLoader()
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*

  -webkit-transition: opacity 15000ms ease,transform 15000ms ease;
  transition: opacity 15000ms ease,transform 15000ms ease;
  */ 
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
}
.slide-right-leave-active {
  opacity: 1;
/*  transform: translate3d(0, 100%, 0);*/
transform: translate3d(0, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(0, 100%, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
}

</style>


// WEBPACK FOOTER //
// src/components/act/1/Index.vue